import { axiosNT } from '../../../services/axios';

const listBySubject = (subjectId: string, classId: string = "") => axiosNT
	.get(`/chapter/chapterListBySubject?classId=${classId}`, { params: { subjectId } })
	.then((res: any) => Promise.resolve(res.responseObject));

const listBySubSubject = (id: string, classId: string = "") => axiosNT
	.get(`/chapter/bySubSubjectId/${id}?classId=${classId}`)
	.then((res: any) => Promise.resolve(res.responseObject));

const listBySubSubjectByGoal = (subSubjectIds: string[], courseTypeIds: string[]) => axiosNT
	.post('/courseSyllabus/v4/chapter', {
		subSubjectIds,
		courseTypeIds
	})
	.then((res: any) => Promise.resolve(res.responseObject.chapters));

export default {
	listBySubject,
	listBySubSubject,
	listBySubSubjectByGoal
};